import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { TextField, Typography } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { UserContext } from "../../../contexts/UserContext";
import { PatronContext } from "../../../contexts/PatronContext";

function SiteChooser() {
  const [allSites, setAllSites] = useState([]);
  const { Site, Sites, currentSite, userRole, changeSite, getMe, getAllSites } =
    useContext(UserContext);
  const { selectPatron } = useContext(PatronContext);

  const [selectedSite, setSelectedSite] = useState();
  const [inputValue, setInputValue] = React.useState("");

  const handleChange = async (event, site) => {
    if (site) {
      await changeSite(site.siteCode);
      await getMe();
      setSelectedSite(site.siteCode);
      selectPatron();
    }
  };

  useEffect(() => {
    getAllSites().then((sites) => setAllSites(sites));
    if (userRole === "admin") {
      let curSite = allSites.filter((site) => site.siteCode === currentSite);
      setSelectedSite(curSite[0]);
    } else {
      let curSite = Sites.filter((site) => site.siteCode === currentSite);
      setSelectedSite(curSite[0]);
    }
    //eslint-disable-next-line
  }, [userRole]);

  return (
    <Container>
      <SiteName>
        Current site: <Bold>{Site.name}</Bold>
      </SiteName>
      {Sites.length > 1 && (
        <Autocomplete
          id="site-chooser"
          options={userRole === "admin" ? allSites : Sites}
          getOptionLabel={(option) => option.name}
          style={{ width: 300 }}
          renderInput={(params) => (
            <TextField {...params} label="Select site" />
          )}
          value={selectedSite}
          onChange={handleChange}
          inputValue={inputValue}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
          }}
          autoSelect
        />
      )}
    </Container>
  );
}

const Container = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 5vw;
`;

const SiteName = styled(Typography)``;

const Bold = styled.span`
  font-weight: 700;
`;

export default SiteChooser;
